<div class="header-container">
    <div class="header">Acceptance of Terms and Conditions</div>
</div>

<div style="margin: 10px 0 20px 0;">
    <span>Please read and accept the Terms and Conditions details below in order to access the application. </span>
</div>

<div *ngFor="let term of terms">
    <div class="check-box-container">
        <mat-checkbox [disabled]="term.accepted && term.acceptedDate" [(ngModel)]="term.accepted" (change)="checkSelectedConditions()"></mat-checkbox>
<!--        <span style="margin-left: 5px">I accept the</span>-->
        <span style="margin-left: 5px;padding-top: 11px;">{{term?.text}} <a target="_blank" [href]="term.link">{{term.name}}</a></span>
    </div>
</div>

<div class="button-container">
    <div style="display: flex;flex-direction: row;align-items: center">
        <button class="cancel-btn mdc-button mdc-button--outlined" (click)="closeDialog()" type="button">
            <div class="create-season-back-btn-content">
                <span class="cancel-btn-text">Cancel</span>
            </div>
        </button>

        <button mat-button  class="accept-button" (click)="closeDialog(true)" [disabled]="!allConditionsSelected">I accept the above terms and conditions</button>
    </div>
</div>